import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getDocumentTypeEntities from '../../services/documentTypeEntities/getDocumentTypeEntities'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchDocumentTypeEntities () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const documentTypeEntities = yield call(getDocumentTypeEntities, auth.token)
    yield put(fetchCombosSuccess({ documentTypeEntities }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }

    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchDocumentTypeEntities () {
  yield takeLatest(combosActionTypes.FETCH_DOCUMENT_TYPE_ENTITIES, fetchDocumentTypeEntities)
}
